module.exports = __webpack_public_path__ + "static/scale-model-of-road-dog-tours---coffee-tour-in-seattle-washington-84e59c56703261aa5c14505164ddbf6d.png";